/* @ngInject */
function ProfilePictureController($rootScope, $scope) {
  const $ctrl = this;

  const onInit = () => {
    $ctrl.user = $scope.teamMember ? $scope.teamMember : $rootScope.user;
    $ctrl.picture = $ctrl.user.profileImg ? $ctrl.user.profileImg.url : "/img/avatar-base-user.png";
  };

  onInit();

  $scope.$on("refreshUser", function () {
    onInit();
  });
}

function profilePicture() {
  return {
    restrict: "E",
    scope: {
      teamMember: "=?user",
    },
    replace: true,
    controllerAs: "$ctrl",
    controller: ProfilePictureController,
    template: `<img ng-src="{{$ctrl.picture}}">`,
  };
}

export default profilePicture;
